import React, { useState, useEffect, useRef } from 'react';
import api from "api";import 'styles/quotesearch.css';

const QuoteSearchBar = (
    {
       quoteid, // numéro du devis
       setObjectToReload, // initialise un équipement à recharger 
       group, // groupe sélectionnée
       deliveryAdd, // flag pour ajout sans tarification
    }
) => {
    const [searchTerm, setSearchTerm] = useState(''); // champ de saisie du matériel recherché
    const [items, setItems] = useState([]); // liste de matériel
    const [selectedItem, setSelectedItem] = useState(null) // maatériel recherché (saisie validée)
    const [quantity,setQuantity] = useState('1'); // quantité du matériel recherché
    const inputRef = useRef(null); // le champ de saisie de la quantité
    const searchBarRef = useRef(null); // le champ de saisie de l'équipement

    // récupère la liste de matériel
    useEffect(() => {
        api.get(`items`)
        .then(response => {
            setItems(response.data);
        });
    }, []);

    // donne les focus (nom ou quantité)
    useEffect(() => {
        if (selectedItem && inputRef.current) {
            if (inputRef.current!==document.activeElement) inputRef.current.focus();
        }
        if (!selectedItem && searchBarRef.current) {
            if (searchBarRef.current!==document.activeElement) searchBarRef.current.focus();
        }
    }, [selectedItem]);
    
    // réinitialise les états au nettoyage de la barre de recherche
    useEffect(()=>{
        if (searchTerm==='') {
            setSelectedItem(null);
            setQuantity('1');
        }
    },[searchTerm]);

    // gère le champ de saisie
    const onChange = (event)=>{
        setSearchTerm(event.target.value);
        const selected = items.find(
            (item) => `${item.name} - ${item.desc}` === event.target.value
        );
        if (selected) {
            setSelectedItem(selected);
        }
    };
    
    // gère les touches ENTRÉE et ÉCHAP pour le nom de l'équipement
    const handleKey = (event) => {
        if (event.key === 'Enter' && searchTerm !== '') {
            const matches = items.filter((item) => {
                const combinedString = `${item.name} - ${item.desc}`.toLowerCase();
                const targetValue = event.target.value.toLowerCase();
                return combinedString.includes(targetValue);
            });
            if (!matches) {
                setSearchTerm('');
                return;
            }
            const selected = matches.length === 1 ? matches[0] : null;
            if (selected) {
                const combinedString = `${selected.name} - ${selected.desc}`;
                setSelectedItem(selected);
                setSearchTerm(combinedString);
            }
        }
        if (event.key === 'Escape') {
            if (searchTerm !=='') {
                event.stopPropagation();
                setSearchTerm('');
            }
        }
    };

    // gère les touches PLUS, MOINS, ENTRÉE et ÉCHAP pour le nombre d'équipement
    const quantityKey = (event) => {
        if (event.key === 'Enter') {
            const qty = Math.max(1, parseInt(quantity) || 1);
            if (!deliveryAdd) {
                api.post(`item/add`, {
                    item : selectedItem.id,
                    quantity : qty,
                    quote : quoteid,
                    group : group?.id ?? null,
                })
                .then(()=>{
                    setSearchTerm('');
                    setObjectToReload(selectedItem);
                });
            }
            else {
                setSearchTerm('');
                setObjectToReload(selectedItem, qty);
            }
        }
        if (event.key === 'Escape') {
            event.stopPropagation();
            setSearchTerm('');
        }
        if (event.key === '+') {
            handleClick(+1);
            onFocus();
        }
        if (event.key === '-') {
            handleClick(-1);
            onFocus();
        }
    };

    // gère le champ quantité
    const onChangeQuantity = (event) => {
        const val = event.target.value;
        if (val === '' || val === '-') { setQuantity(''); return; }
        const n = parseInt(val);
        if (isNaN(n) || n < 1) return;
        setQuantity(String(n));
    }

    // gère les boutons quantité
    const handleClick = (sign) => {
        const current = Math.max(1, parseInt(quantity) || 1);
        if (sign>0) setQuantity(String(current + 1));
        if (sign<0) setQuantity(String(Math.max(1, current - 1)));
    };

    // sélectionne la quantité au focus
    const onFocus = () => {
        setTimeout(() => {
            inputRef.current.select();
        }, 0);        
    };

    return (
        <>
            <div
                className='QuoteText'
                id='QuoteSearchBar'
            >
                <input
                    list="items"
                    type="text"
                    placeholder="Rechercher..."
                    value={searchTerm}
                    onChange={onChange}
                    onKeyDown={handleKey}
                    ref={searchBarRef}
                />
                {   
                    searchTerm
                    &&  
                    <datalist id="items">
                        {items.map((item) => (
                            <option key={item.id} value={`${item.name} - ${item.desc}`}/>
                        ))}
                    </datalist>
                }
                </div>
        
            {
                selectedItem
                &&
                <div
                    className='QuoteQuantity'
                >
                    <div
                        className='QuoteQuantityButton'
                        onMouseDown={e => e.preventDefault()}
                        onClick={()=>handleClick(-1)}
                    >
                        -
                    </div>
                    <input
                        className='QuoteQuantityInput'
                        type='text'
                        value={quantity}
                        onChange={onChangeQuantity}
                        onKeyDown={quantityKey}
                        ref={inputRef}
                        onFocus={onFocus}
                    >  
                    </input>
                    <div
                        className='QuoteQuantityButton'
                        onMouseDown={e => e.preventDefault()}
                        onClick={()=>handleClick(+1)}
                    >
                        +
                    </div>
                </div>
            }
            
        </>
    );
}

export default QuoteSearchBar;